import PastNotes from "modules/PastNotes/View";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

function BUCustomerSuccessPastNotes() {
  return (
    <PastNotes
      entityType={ENotesEntity.BUSINESS_UNIT}
      pipelineSlug={EPipelineSlug.CUSTOMER_SUCCESS}
    />
  );
}

export default BUCustomerSuccessPastNotes;
